angular.module('picmonicng').controller('PlaylistController', [
  '$scope',
  '$rootScope',
  '$filter',
  '$modal',
  'UserService',
  'Playlists',
  'Modal',
  'PlaylistService',
  'LearnService',
  'TokenService',
  'PicmonicQueue',
  'BrowseService',
  '$browseStateParams',
  '$interval',
  'PrintAndGoService',
  'ngBowser',
  '$state',
  'StudySchedulerModal',
  function (
    $scope,
    $rootScope,
    $filter,
    $modal,
    UserService,
    Playlists,
    Modal,
    PlaylistService,
    LearnService,
    TokenService,
    PicmonicQueue,
    BrowseService,
    $browseStateParams,
    $interval,
    PrintAndGoService,
    ngBowser,
    $state,
    StudySchedulerModal
  ) {
    $scope.PlaylistService = PlaylistService;
    $scope.mobile = ngBowser.isMobile() || ngBowser.isTablet();
    $scope.playlist = PlaylistService.getPlaylist($browseStateParams.playlist_id);
    $scope.playlist.$promise.then(function () {
      if (Number.isInteger($scope.playlist.playlist_id)) {
        $scope.real = 1;
      }
    });
    $scope.loadingPicmonics = true;
    $scope.outstandingRequests = 0;
    $scope.UserService = UserService;

    var move_queue = [];

    function nextMoveRequest() {
      if (!move_queue.length) {
        return;
      }
      $scope.playlist.updates_in_progress++;

      var card = move_queue.shift();
      var promise = Playlists.update(card).$promise.then(function () {
        $scope.playlist.updates_in_progress--;
        if (!move_queue.length) {
          $rootScope.$broadcast('playlistCardDataChanged', {
            action: 'moveCard',
            card_id: card.card_id,
            playlist_id: $scope.playlist.playlist_id,
            promise: promise,
          });
        } else {
          nextMoveRequest();
        }
      });
    }

    $scope.getPicmonics = function () {
      var promise = PlaylistService.getCards({
        playlist_id: $browseStateParams.playlist_id,
      });
      promise.$promise
        .then(function (picmonics) {
          if (!$scope.playlist.updates_in_progress) {
            $scope.picmonics = picmonics;
            $scope.sortCards();
          }
        })
        .finally(function () {
          $scope.loadingPicmonics = false;
        });

      return promise;
    };

    if (
      UserService.user.playlist_mode != 'playlist' ||
      UserService.user.current_playlist != $browseStateParams.playlist_id
    ) {
      UserService.user.playlist_mode = 'playlist';
      UserService.user.current_playlist = $browseStateParams.playlist_id;
      UserService.user.$update();
    }

    $scope.orderOptions = [
      { value: 'custom', label: 'Custom', column: 'sort_order' },
      { value: 'a~z', label: 'Title A-Z', column: 'name' },
      { value: 'z~a', label: 'Title Z-A', column: '-name' },
      { value: 'random', label: 'Shuffle', column: 'random_order' },
    ];

    $scope.playlist.$promise.then(function () {
      if ($scope.playlist.auto) {
        $scope.orderOptions.shift();
      }

      $scope.playlist.updates_in_progress = 0;
      $scope.sortMethod = $filter('filter')($scope.orderOptions, {
        value: $scope.playlist.sort_method,
      })[0];

      $scope.getPicmonics();
      $scope.$emit('endInteraction');
    });

    $scope.getSortOrder = function () {
      return $filter('filter')($scope.orderOptions, {
        value: $scope.playlist.sort_method,
      })[0];
    };

    $scope.setSortOrder = function (sortMethod) {
      $scope.sortMethod = sortMethod;
      $scope.playlist.sort_method = sortMethod.value;
      $scope.playlist.$update();

      $scope.sortCards();

      send_ga('event', 'Playlist', 'Sort By ' + $scope.getSortOrder().label);
    };

    $scope.sortCards = function () {
      $scope.picmonics = $filter('orderBy')($scope.picmonics, $scope.sortMethod.column);
    };

    $scope.learn = function (e, picmonic) {
      var newTab = false;
      if (e && (e.shiftKey || e.ctrlKey || e.metaKey)) {
        newTab = true;
      }

      if (picmonic) {
        PicmonicQueue.setAndPlay(
          $scope.picmonics,
          picmonic.card_id,
          null,
          null,
          $browseStateParams.playlist_id,
          newTab
        );
      } else {
        PicmonicQueue.setAndPlay(
          $filter('orderBy')($scope.picmonics, ['viewed_flag', 'attempted_flag', 'mastered_flag', 'sort_order']),
          null,
          null,
          null,
          $browseStateParams.playlist_id
        );
        send_ga('event', 'Playlist', 'Learn Playlist');
      }
    };

    $scope.moveCard = function (card, position) {
      var newpos = position.sort_order,
        oldpos = card.sort_order,
        a,
        item;

      //move down
      if (oldpos > newpos) {
        for (a in $scope.picmonics) {
          item = $scope.picmonics[a];
          if (item != card && item.sort_order >= newpos && item.sort_order <= oldpos) {
            item.sort_order += 1;
          }
        }
        //move up
      } else {
        for (a in $scope.picmonics) {
          item = $scope.picmonics[a];
          if (item != card && item.sort_order <= newpos && item.sort_order >= oldpos) {
            item.sort_order -= 1;
          }
        }
      }

      card.resource = 'picmonics';
      card.playlist_id = $scope.playlist.playlist_id;
      card.sort_order = newpos;

      $scope.sortCards();

      move_queue.push(angular.copy(card));
      if (move_queue.length === 1) {
        nextMoveRequest();
      }
    };

    //Duplicate playlist then go to new playlist
    $scope.duplicate = function () {
      PlaylistService.duplicate($scope.playlist).then(function (response) {
        BrowseService.go('app.playlist', { playlist_id: response.playlist_id });
      });
    };

    //Rename playlist
    $scope.rename = function () {
      PlaylistService.rename($scope.playlist).then(function (response) {
        $scope.playlist.name = response.name;
      });
    };

    //Clear picmonics from a playlist
    $scope.clear = function () {
      PlaylistService.clear($scope.playlist).then(function () {
        $scope.picmonics = [];
        PlaylistService.getPlaylist($scope.playlist.playlist_id).$promise.then(function (playlist) {
          $scope.playlist = playlist;
        });
      });
    };

    //Delete a playlist
    $scope.delete = function () {
      PlaylistService.delete($scope.playlist).then(function () {
        $scope.back();
      });
    };

    $scope.user = UserService.user;

    $scope.quizPlaylist = function (playlist) {
      PicmonicQueue.goToQuiz(playlist.playlist_id, 'playlist', $scope.playlist.total_facts);
    };

    $scope.createStudySchedule = function (playlist) {
      StudySchedulerModal.show(null, null, playlist);
    };

    $scope.startSpacedRep = function (playlist) {
      if (!UserService.user.has_seen.spaced_rep_filter) {
        $modal.open({
          templateUrl: '/templates/modals/quiz-spacedrep.html',
          windowClass: 'pls-modal-spaced-rep',
          size: 'md',
          backdropClass: 'above-nav',
          controller: [
            '$scope',
            function ($scope) {
              $scope.resourceName = playlist.name;

              $scope.startSpacedRep = function () {
                if ($scope.hideModal) {
                  UserService.see('spaced_rep_filter');
                }

                $state.go('app.quiz', {
                  card_id: null,
                  track_id: null,
                  pathway_id: null,
                  playlist_id: playlist.playlist_id,
                  quiz_type: 'spacedrep',
                  resource_id: 'today',
                });
              };
            },
          ],
        });
      } else {
        $state.go('app.quiz', {
          playlist_id: playlist.playlist_id,
          quiz_type: 'spacedrep',
          resource_id: 'today',
        });
      }
    };

    $scope.LearnService = LearnService;

    $scope.$on('playlistCardDataChanged', function (event, data) {
      //If the playlist data event was a card being removed, and it was being removed from this playlist
      if (data.playlist_id == $browseStateParams.playlist_id) {
        $scope.outstandingRequests++;

        switch (data.action) {
          case 'removeCard':
            //Immediately splice the card from the array so the picmonic disappears from the UI
            $scope.picmonics.splice($filter('arrayPos')($scope.picmonics, data.card_id, 'card_id'), 1);
            break;
          case 'moveCard':
            $scope.outstandingRequests--;
            return;
        }

        //Wait for the API call the action to be completed, then update playlist picmonic data
        data.promise.then(function () {
          $scope.outstandingRequests--;
          if ($scope.outstandingRequests === 0) {
            $scope.getPicmonics();
          }
        });
      }
    });

    $scope.$on('cardDataChanged', function (event, data) {
      if ($filter('filter')($scope.picmonics, { card_id: data.card_id }).length) {
        if ($scope.outstandingRequests === 0) {
          $scope.getPicmonics();
        }
      }
    });

    $scope.dragControlListeners = {
      orderChanged: function (event) {
        $scope.moveCard(event.source.itemScope.picmonic, event.dest.index, $scope.offset);
      },
      dragMove: function (position, containment, e) {
        if (e) {
          var rect = containment[0].getBoundingClientRect();
          if (position.lastY < rect.top) {
            containment[0].scrollTop = containment[0].scrollTop - 25;
          } else if (position.lastY > rect.bottom) {
            containment[0].scrollTop = containment[0].scrollTop + 25;
          }
        }
      },
      containment: '.playlist-picmonics',
      longTouch: true,
    };

    $scope.back = function () {
      if (BrowseService.secondaryVisible === false) {
        BrowseService.go('home', {
          visible_content: 'playlist',
          playlist_id: $scope.playlist.playlist_id,
        });
      } else {
        BrowseService.go('app.playlists');
      }
    };

    $scope.print = function (layout) {
      PrintAndGoService.print('playlist', $scope.playlist.playlist_id, layout);
    };

    $scope.clickMoreMenu = function () {
      UserService.see('playlist_more_menu');
    };

    $scope.studySchedulerEnabled =
      UserService.user.settings.show_study_scheduler ||
      UserService.user.email.indexOf('@picmonic.com') > -1 ||
      !UserService.user.is_trial;
  },
]);
